// extracted by mini-css-extract-plugin
module.exports = {"team-tag":"PAcRVgMoEijd8QPWyajC","container":"_27sbQ0IeH6KgcNgdEdAx","select":"_g9LmmRwUkucE-x137nC"};